"use strict";
/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// /revet-web/node_modules/@uirouter/core/lib/resolve/interface.js
// module id = ../../../../@uirouter/core/lib/resolve/interface.js
// module chunks = vendor